/** @jsxImportSource @emotion/react */
import React from 'react';
import map from 'lodash/map';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { reportContentActions } from './reportContetSlice';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { defaultTab, subTab } from '../../common/styles/TabStyles';
import styled from '@emotion/styled';

function SubDiseaseTab() {
  const dispatch = useAppDispatch();
  const [subDiseaseList, value] = useAppSelector((state) => [
    reportContentActions.getSubDiseaseList(state),
    reportContentActions.selectedSubDiseaseSelector(state),
  ]);

  return (
    <section css={[defaultTab, subTab]}>
      <Tabs
        value={value}
        onChange={(e, v) =>
          dispatch(reportContentActions.setSelectSubDisease(String(v)))
        }
        variant="scrollable"
      >
        {map(subDiseaseList, ({ id, label, isWarn }) => {
          return (
            <Tab
              key={id}
              label={
                <TabDiv>
                  <div>{label}</div>
                  {isWarn ? <Indicator /> : null}
                </TabDiv>
              }
              value={String(id)}
            />
          );
        })}
      </Tabs>
    </section>
  );
}
const TabDiv = styled.div`
  flex-direction: row;
  display: flex;
`;
const Indicator = styled.div`
  background-color: ${(props) => props.theme.palette.primary1};
  width: 4px;
  height: 4px;
  border-radius: 16px;
`;

export default SubDiseaseTab;
